export var ExpandTrigger;
(function (ExpandTrigger) {
    ExpandTrigger["click"] = "click";
    ExpandTrigger["hover"] = "hover";
})(ExpandTrigger || (ExpandTrigger = {}));
